import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * NewsEntriesApi - axios parameter creator
 * @export
 */
const NewsEntriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryGetAllRequest} [NewsEntryGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (NewsEntryGetAllRequest, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(NewsEntryGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {boolean} [shouldEnrich]
         * @param {string} [cids]
         * @param {string} [groupCode]
         * @param {boolean} [isFeatured]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntries: async (pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetAllEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (shouldEnrich !== undefined) {
                localVarQueryParameter['shouldEnrich'] = shouldEnrich;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            if (groupCode !== undefined) {
                localVarQueryParameter['groupCode'] = groupCode;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, enrich, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [groupCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByNewsCategoryId: async (id, pageIndex, pageSize, groupCode, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetByNewsCategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (groupCode !== undefined) {
                localVarQueryParameter['groupCode'] = groupCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShowFront: async (page, psize, cids, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetByShowFront`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl: async (url, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetByUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntriesByProductId: async (id, cids, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetNewsEntriesByProductId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntriesSources: async (options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetNewsEntriesSources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntryVisibilities: async (options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetNewsEntryVisibilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [newsEntryId]
         * @param {number} [newsEntryCatId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedNewsEntries: async (newsEntryId, newsEntryCatId, options = {}) => {
            const localVarPath = `/v1/NewsEntries/GetRelatedNewsEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (newsEntryId !== undefined) {
                localVarQueryParameter['newsEntryId'] = newsEntryId;
            }
            if (newsEntryCatId !== undefined) {
                localVarQueryParameter['newsEntryCatId'] = newsEntryCatId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is accessible anonymously and is intended to update the page view count for a visible             and non-deleted news entry.
         * @summary Increments the page view count for a specified news entry.
         * @param {IncrementPageViewsRequest} [IncrementPageViewsRequest] The request containing the ID of the news entry for which the page view count should be incremented. The BizWeb.NC.API.Controllers.NewsEntriesController.IncrementPageViewsRequest.NewsEntryId property must be a positive integer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incrementPageViews: async (IncrementPageViewsRequest, options = {}) => {
            const localVarPath = `/v1/NewsEntries/IncrementPageViews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(IncrementPageViewsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (NewsEntryToken, options = {}) => {
            const localVarPath = `/v1/NewsEntries/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(NewsEntryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/NewsEntries/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q, page, psize, options = {}) => {
            const localVarPath = `/v1/NewsEntries/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (NewsEntryToken, options = {}) => {
            const localVarPath = `/v1/NewsEntries/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(NewsEntryToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryProductsDisplayModeBatchRequest} [NewsEntryProductsDisplayModeBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsDisplayModeBatch: async (NewsEntryProductsDisplayModeBatchRequest, options = {}) => {
            const localVarPath = `/v1/NewsEntries/UpdateProductsDisplayModeBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(NewsEntryProductsDisplayModeBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NewsEntriesApi - functional programming interface
 * @export
 */
const NewsEntriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = NewsEntriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryGetAllRequest} [NewsEntryGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(NewsEntryGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(NewsEntryGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {boolean} [shouldEnrich]
         * @param {string} [cids]
         * @param {string} [groupCode]
         * @param {boolean} [isFeatured]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getAllEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, enrich, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, enrich, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [groupCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getByNewsCategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByShowFront(page, psize, cids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByShowFront(page, psize, cids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getByShowFront']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUrl(url, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUrl(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getByUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsEntriesByProductId(id, cids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsEntriesByProductId(id, cids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getNewsEntriesByProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsEntriesSources(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsEntriesSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getNewsEntriesSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsEntryVisibilities(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsEntryVisibilities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getNewsEntryVisibilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [newsEntryId]
         * @param {number} [newsEntryCatId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedNewsEntries(newsEntryId, newsEntryCatId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedNewsEntries(newsEntryId, newsEntryCatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.getRelatedNewsEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This method is accessible anonymously and is intended to update the page view count for a visible             and non-deleted news entry.
         * @summary Increments the page view count for a specified news entry.
         * @param {IncrementPageViewsRequest} [IncrementPageViewsRequest] The request containing the ID of the news entry for which the page view count should be incremented. The BizWeb.NC.API.Controllers.NewsEntriesController.IncrementPageViewsRequest.NewsEntryId property must be a positive integer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async incrementPageViews(IncrementPageViewsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.incrementPageViews(IncrementPageViewsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.incrementPageViews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(NewsEntryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(NewsEntryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(NewsEntryToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(NewsEntryToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryProductsDisplayModeBatchRequest} [NewsEntryProductsDisplayModeBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsEntriesApi.updateProductsDisplayModeBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * NewsEntriesApi - factory interface
 * @export
 */
const NewsEntriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NewsEntriesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryGetAllRequest} [NewsEntryGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(NewsEntryGetAllRequest, options) {
            return localVarFp.getAll(NewsEntryGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {boolean} [shouldEnrich]
         * @param {string} [cids]
         * @param {string} [groupCode]
         * @param {boolean} [isFeatured]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options) {
            return localVarFp.getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {boolean} [enrich]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, enrich, options) {
            return localVarFp.getByIds(request_body, enrich, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [groupCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options) {
            return localVarFp.getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByShowFront(page, psize, cids, options) {
            return localVarFp.getByShowFront(page, psize, cids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUrl(url, options) {
            return localVarFp.getByUrl(url, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntriesByProductId(id, cids, options) {
            return localVarFp.getNewsEntriesByProductId(id, cids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntriesSources(options) {
            return localVarFp.getNewsEntriesSources(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntryVisibilities(options) {
            return localVarFp.getNewsEntryVisibilities(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [newsEntryId]
         * @param {number} [newsEntryCatId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedNewsEntries(newsEntryId, newsEntryCatId, options) {
            return localVarFp.getRelatedNewsEntries(newsEntryId, newsEntryCatId, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is accessible anonymously and is intended to update the page view count for a visible             and non-deleted news entry.
         * @summary Increments the page view count for a specified news entry.
         * @param {IncrementPageViewsRequest} [IncrementPageViewsRequest] The request containing the ID of the news entry for which the page view count should be incremented. The BizWeb.NC.API.Controllers.NewsEntriesController.IncrementPageViewsRequest.NewsEntryId property must be a positive integer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        incrementPageViews(IncrementPageViewsRequest, options) {
            return localVarFp.incrementPageViews(IncrementPageViewsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(NewsEntryToken, options) {
            return localVarFp.insert(NewsEntryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q, page, psize, options) {
            return localVarFp.search(q, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryToken} [NewsEntryToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(NewsEntryToken, options) {
            return localVarFp.update(NewsEntryToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {NewsEntryProductsDisplayModeBatchRequest} [NewsEntryProductsDisplayModeBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options) {
            return localVarFp.updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewsEntriesApi - object-oriented interface
 * @export
 * @class NewsEntriesApi
 * @extends {BaseAPI}
 */
class NewsEntriesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {NewsEntryGetAllRequest} [NewsEntryGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getAll(NewsEntryGetAllRequest, options) {
        return NewsEntriesApiFp(this.configuration).getAll(NewsEntryGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [pageIndex]
     * @param {number} [pageSize]
     * @param {boolean} [shouldEnrich]
     * @param {string} [cids]
     * @param {string} [groupCode]
     * @param {boolean} [isFeatured]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options) {
        return NewsEntriesApiFp(this.configuration).getAllEntries(pageIndex, pageSize, shouldEnrich, cids, groupCode, isFeatured, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getById(id, options) {
        return NewsEntriesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} [request_body]
     * @param {boolean} [enrich]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getByIds(request_body, enrich, options) {
        return NewsEntriesApiFp(this.configuration).getByIds(request_body, enrich, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {number} [pageIndex]
     * @param {number} [pageSize]
     * @param {string} [groupCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options) {
        return NewsEntriesApiFp(this.configuration).getByNewsCategoryId(id, pageIndex, pageSize, groupCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page]
     * @param {number} [psize]
     * @param {string} [cids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getByShowFront(page, psize, cids, options) {
        return NewsEntriesApiFp(this.configuration).getByShowFront(page, psize, cids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getByUrl(url, options) {
        return NewsEntriesApiFp(this.configuration).getByUrl(url, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [cids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getNewsEntriesByProductId(id, cids, options) {
        return NewsEntriesApiFp(this.configuration).getNewsEntriesByProductId(id, cids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getNewsEntriesSources(options) {
        return NewsEntriesApiFp(this.configuration).getNewsEntriesSources(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getNewsEntryVisibilities(options) {
        return NewsEntriesApiFp(this.configuration).getNewsEntryVisibilities(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [newsEntryId]
     * @param {number} [newsEntryCatId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    getRelatedNewsEntries(newsEntryId, newsEntryCatId, options) {
        return NewsEntriesApiFp(this.configuration).getRelatedNewsEntries(newsEntryId, newsEntryCatId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is accessible anonymously and is intended to update the page view count for a visible             and non-deleted news entry.
     * @summary Increments the page view count for a specified news entry.
     * @param {IncrementPageViewsRequest} [IncrementPageViewsRequest] The request containing the ID of the news entry for which the page view count should be incremented. The BizWeb.NC.API.Controllers.NewsEntriesController.IncrementPageViewsRequest.NewsEntryId property must be a positive integer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    incrementPageViews(IncrementPageViewsRequest, options) {
        return NewsEntriesApiFp(this.configuration).incrementPageViews(IncrementPageViewsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {NewsEntryToken} [NewsEntryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    insert(NewsEntryToken, options) {
        return NewsEntriesApiFp(this.configuration).insert(NewsEntryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    remove(id, options) {
        return NewsEntriesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    search(q, page, psize, options) {
        return NewsEntriesApiFp(this.configuration).search(q, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {NewsEntryToken} [NewsEntryToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    update(NewsEntryToken, options) {
        return NewsEntriesApiFp(this.configuration).update(NewsEntryToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {NewsEntryProductsDisplayModeBatchRequest} [NewsEntryProductsDisplayModeBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEntriesApi
     */
    updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options) {
        return NewsEntriesApiFp(this.configuration).updateProductsDisplayModeBatch(NewsEntryProductsDisplayModeBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export { NewsEntriesApi, NewsEntriesApiAxiosParamCreator, NewsEntriesApiFactory, NewsEntriesApiFp };
//# sourceMappingURL=news-entries-api.js.map
